<!--suppress ALL -->
<template>
  <b-card
    v-if="!loading"
    :class="['mb-30 text-15 w-100 mh-210']"
    :header="client.name"
    header-tag="h5"
  >
    <b-row>
      <b-col md="6">
        <div
          class="project-colour"
          :style="selectedColour"
          @click="toggleColorPicker"
        ></div>
        <color-picker
          v-show="selectColour"
          v-model="colour"
          class="colour-picker"
          :palette="colorPalete"
        />
      </b-col>

      <b-col md="6" class="same-line">
        <template v-if="client.incompleteTasks">
          <b-icon-list-task> </b-icon-list-task> :
          <b class="m-r-10">{{ client.incompleteTasks }}</b>
        </template>
        <template v-if="client.incompleteTickets">
          <font-awesome-icon class="ticket" icon="ticket-alt">
          </font-awesome-icon>
          :
          <b class="m-r-10">{{ client.incompleteTickets }}</b>
        </template>
      </b-col>
    </b-row>
    <b-row class="time-text">
      <b-col md="12">
        Monthly Support Hours
      </b-col>
      <b-col md="6">Allocated:</b-col>
      <b-col md="6">{{ client.supportTime }}</b-col>
      <b-col md="6">Used:</b-col>
      <b-col md="6">{{ getTotalBillableHours(client) }}</b-col>
      <b-col md="6">Remaining:</b-col>
      <b-col md="6">{{ getRemainingHours(client) }}</b-col>
      <b-col md="6">Other Hours:</b-col>
      <b-col md="6">{{ getOtherHours(client) }}</b-col>
    </b-row>

    <!-- {{ client.incomplete.incompleteTasks }}
      {{ client.incomplete.incompleteTickets }} -->
    <!-- <ProjectAvatar
      v-for="user in client.users"
      :key="user.id"
      class="avatar"
      :user="user"
    /> -->
    <div>
      <ShowTimeButton :client-id="client.id" />

      <router-link :to="`/Client/${client.id}`">
        <b-button variant="outline-primary m-1 btn-sm position-bottom"
          >View</b-button
        >
      </router-link>
    </div>
  </b-card>
</template>
<script>
// import ProjectAvatar from "@/components/projectAvatar"
import { Compact } from "vue-color"
import Util from "@/utils"
import ShowTimeButton from "@/components/client/showTimeButton"

export default {
  components: {
    "color-picker": Compact,
    ShowTimeButton
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    client: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      colour: {
        hex: "#194d33"
      },
      selectColour: false,
      colorPalete: [
        "#5bc0de",
        "#5cb85c",
        "#428bca",
        "#96ceb4",
        "#ffeead",
        "#ff6f69",
        "#ffcc5c",
        "#88d8b0",
        "#00b159",
        "#ffc425",
        "#f37735",
        "#b3ecec",
        "#ffd460",
        "#2f7eb5",
        "#479cc1",
        "#76d7da",
        "#519051",
        "#07F85E",
        "#F807A1",
        "#85F00F",
        "#FFEE34",
        "#55FFF9",
        "#FF555B",
        "#077CF8",
        "#BBFE01",
        "#89FE24",
        "#24FE01",
        "#FEDB01",
        "#4FF4FC",
        "#AD4FFC",
        "#FC574F",
        "#9DFC4F",
        "#FF52C8"
      ]
    }
  },
  computed: {
    selectedColour() {
      return {
        backgroundColor: this.colour.hex
      }
    }
  },
  watch: {
    colour: {
      handler(val) {
        if (!this.loading) {
          this.client.colour = val.hex
          this.$emit("colour-changed", this.client)
        }
      }
    }
  },
  created() {
    this.colour.hex = this.client.colour
    this.loading = false
  },
  methods: {
    /**
     * Gets the remaining Billable hours for client
     * @param client
     * @returns {number}
     */
    getRemainingHours(client) {
      let total = this.getTotalBillableHours(client)

      total = total == 0 ? client.supportTime : client.supportTime - total
      total = parseFloat(total.toFixed(2))
      client.remaining = total
      return total
    },
    /**
     * Gets the total Billable hours for client
     * @param client
     * @returns {number}
     */
    getTotalBillableHours(client) {
      let total = 0
      if (!client.timeLogs?.some(x => x)) total = 0
      else
        client.timeLogs.forEach(c => {
          total +=
            (c.type === "Billable" || c.type === "Unsure") && c.support
              ? c.time
              : 0 || 0
        })
      total = parseFloat(total.toFixed(2))
      return total
    },
    /**
     * Gets Non-Billable/Support hours logged for client
     * @param client
     * @returns {number}
     */
    getOtherHours(client) {
      let total = 0
      if (!client.timeLogs?.some(x => x)) return total
      else
        client.timeLogs.forEach(c => {
          total += (!c.support ? c.time : 0) || 0
        })

      return parseFloat(total.toFixed(2))
    },
    toLink: function(projectName) {
      return Util.stringToLink(projectName)
    },
    toggleColorPicker() {
      this.selectColour = !this.selectColour
    }
  }
}
</script>
<style scoped>
.avatar {
  margin-right: 20px;
}
.colour-picker {
  margin-bottom: 10px;
}
.project-colour {
  width: 100%;
  height: 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  max-width: 240px;
}
.project-colour:hover {
  cursor: pointer;
}
.mh-210 {
  min-height: 300px;
}
.mh-200 {
  min-height: 200px;
}
.position-bottom {
  position: absolute;
  bottom: 1rem;
  right: 1.25rem;
}
.card-header {
  font-weight: bold;
}
.project-disabled {
  background: #f7f7f7;
}
.small {
  font-size: 0.85rem !important;
}
.ticket {
  color: darkmagenta;
}
.time-text {
  font-size: larger;
}

.show-time-btn {
  margin-right: 3.5rem !important;
}
</style>
